
import { useState } from "react";
import { ChangelogForm } from "./changelog/ChangelogForm";
import { ChangelogList } from "./changelog/ChangelogList";

export const ChangelogManagement = ({ 
  companyId,
  companyPlan = 'free'
}: { 
  companyId: string;
  companyPlan?: string;
}) => {
  const [key, setKey] = useState(0);

  const handleSuccess = () => {
    setKey(prev => prev + 1);
  };

  return (
    <div className="space-y-6">
      <ChangelogForm companyId={companyId} onSuccess={handleSuccess} companyPlan={companyPlan} />
      <ChangelogList key={key} companyId={companyId} />
    </div>
  );
};
